module.exports = __webpack_public_path__ + "static/media/peer-mentor.af366ea9.jpg";